import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import AnnualJobKanban from './annual_job/AnnualJobKanban';
import PersonalKanban from './project/PersonalKanban';

const MyTasks = () => {
    const [key, setKey] = useState('annual');

    return (
        <div className="container-fluid mt-3">
            <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
                <div className="bg-primary text-white rounded p-2 me-3 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                    <i className="fas fa-tasks fa-lg"></i>
                </div>
                <div>
                    <h2 className="mb-0 text-dark fw-bold" style={{ fontSize: '24px' }}>Nhiệm vụ của tôi</h2>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Nơi tổng hợp tất cả công việc thường niên và công việc đột xuất của bạn</p>
                </div>
            </div>

            <div className="bg-white p-3 pt-2 rounded shadow-sm border">
                <Tabs
                    id="my-tasks-tabs"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-4"
                >
                    <Tab eventKey="annual" title={
                        <span className="px-2 fw-bold" style={{ fontSize: '15px' }}>
                            <i className="fas fa-calendar-alt me-2 text-success"></i>
                            Công việc Thường niên
                        </span>
                    }>
                        <div className="mt-3">
                            <AnnualJobKanban isNested={true} />
                        </div>
                    </Tab>
                    <Tab eventKey="project" title={
                        <span className="px-2 fw-bold" style={{ fontSize: '15px' }}>
                            <i className="fas fa-project-diagram me-2 text-warning"></i>
                            Công việc đột xuất
                        </span>
                    }>
                        <div className="mt-3">
                            <PersonalKanban isNested={true} />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
};

export default MyTasks;
